// D7-06 (FE-6.5) + D5-14 (FE-2.6): shared pull-to-refresh pill, extracted from
// Sidebar so the chat message list renders the identical affordance.
import { cn } from '../../utils';

interface PullToRefreshIndicatorProps {
  isRefreshing: boolean;
  pullDistance: number;
  willRefresh: boolean;
}

export function PullToRefreshIndicator({ isRefreshing, pullDistance, willRefresh }: PullToRefreshIndicatorProps) {
  if (!isRefreshing && pullDistance <= 0) {
    return null;
  }

  return (
    <div
      className="flex items-center justify-center text-xs text-slate-400"
      style={{ height: `${isRefreshing ? 36 : pullDistance}px` }}
      role="status"
      aria-live="polite"
    >
      <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card/95 px-3 py-1.5 text-foreground shadow-sm shadow-black/10">
        <span className={cn('ally-spinner-ring h-3.5 w-3.5', !isRefreshing && 'opacity-70')} />
        <span>{isRefreshing ? 'Refreshing…' : willRefresh ? 'Release to refresh' : 'Pull to refresh'}</span>
      </div>
    </div>
  );
}

export default PullToRefreshIndicator;
